const { gql, request } = require('graphql-request');

const getTotalETHTopUpsInGwei = async (subgraphEndpoint, blsPubKey) => {
  const lookupQuery = gql`
      query getTopUps($id: String!) {
          stakehouseAccount(id: $id) {
              totalETHTopUps
          }
      }
  `;

  const response = await request(
    subgraphEndpoint,
    lookupQuery,
    {
      id: blsPubKey.toLowerCase()
    }
  );

  if (!response || !response.stakehouseAccount || !response.stakehouseAccount.totalETHTopUps) {
    return '0'
  }

  const { totalETHTopUps } = response.stakehouseAccount;
  return totalETHTopUps;
}

module.exports = { getTotalETHTopUpsInGwei }